// Matches the legacy `Cd` atom in app/frontend/index.html.

import { clsx } from "clsx";
import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  style?: CSSProperties;
}

export function Card({ children, className, style, onClick, ...rest }: CardProps) {
  return (
    <div
      {...rest}
      onClick={onClick}
      style={style}
      className={clsx(
        // p-5 on mobile, p-6 from sm+ — gives content room to breathe
        // inside the card rather than kissing the borders. Callers can
        // override via `!p-X` in className if they need denser padding.
        "bg-card border border-stroke rounded p-5 sm:p-6 transition-colors duration-150 animate-fade-in",
        onClick ? "cursor-pointer" : "cursor-default",
        className,
      )}
    >
      {children}
    </div>
  );
}
